import { render, staticRenderFns } from "./CategorySelector.vue?vue&type=template&id=45dfc9ce&scoped=true"
import script from "./CategorySelector.vue?vue&type=script&lang=ts"
export * from "./CategorySelector.vue?vue&type=script&lang=ts"
import style0 from "./CategorySelector.vue?vue&type=style&index=0&id=45dfc9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dfc9ce",
  null
  
)

export default component.exports